import type { JSX, ReactNode } from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'
import type { IPopupComponentProps } from '../PopupComponent.h'

import { TextBoxMaxLine2FontXlBold } from 'atoms/TextBox/Templates'
import { TextAligning } from 'atoms/TextBox/TextBox.h'
import { TextBlock } from 'blocks/TextBlock'
import { COLOR } from 'vars/color'
import { PopupLayout } from 'vars/index'
import { PopupComponent } from '../PopupComponent'
import {
  MotnStreamingServicesListSC,
  MotnStreamingServicesPopupSC,
} from './MotnStreamingServicesPopup.styled'

export interface IMotnStreamingServicesPopupProps extends Omit<
  IPopupComponentProps,
  'children'
> {
  title: ITextBoxProps['title']
  isOpened: boolean
  /** List rows (e.g. from skin `components` + `map`) */
  children?: ReactNode
}

export function MotnStreamingServicesPopup({
  title = '',
  children,
  isOpened = false,
  overlayColor = COLOR.SURFACE_OPACITY_DARK_70,
  popupBackgroundColor = COLOR.SURFACE_DARK_4,
  withGradientScrollableBlock = true,
  horizontalPadding = PopupLayout.motnHorizontalPaddings,
  headerBottomPadding = PopupLayout.motnHeaderBottomPadding,
  onClosePopup,
  ...rest
}: IMotnStreamingServicesPopupProps): JSX.Element | null {
  if (!isOpened) return null

  return (
    <MotnStreamingServicesPopupSC>
      <PopupComponent
        overlayColor={overlayColor}
        popupBackgroundColor={popupBackgroundColor}
        withGradientScrollableBlock={withGradientScrollableBlock}
        horizontalPadding={horizontalPadding}
        headerBottomPadding={headerBottomPadding}
        onClosePopup={onClosePopup}
        {...rest}
      >
        <TextBlock>
          <TextBoxMaxLine2FontXlBold
            title={title}
            alignment={TextAligning.Center}
          />
        </TextBlock>

        <MotnStreamingServicesListSC>{children}</MotnStreamingServicesListSC>
      </PopupComponent>
    </MotnStreamingServicesPopupSC>
  )
}
